<template>
    <v-dialog v-model="show" persistent max-width="700px" max-height="700px">
        <!-- <div id="app"> -->
        <!-- <v-app id="inspire"> -->
        <v-card class="d-flex flex-column" style="max-height: 600px; overflow: hidden;">
            <v-card-title>
                <span class="text-h5">Registro de Cumplimiento de Obligación N°: {{ codgral }}
                    <p> Pago: {{ descr }}
                    </p>
                </span>
            </v-card-title>
            <v-card-text style="overflow: auto;">
                <v-container>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field dense label="Monto:" v-model="monto"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field dense v-model="entidad" label="Entidad"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field dense v-model="numop" label="N° de O.P."></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field dense v-model="archivado" label="Archivado en:"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field dense v-model="fecha" label="Fecha de Pago:"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="show = false">
                    Cerrar
                </v-btn>
                <v-btn color="blue darken-1" text :disabled="deshabilitar" @click="guardar()">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
        <!-- </v-app> -->
        <!-- </div> -->
    </v-dialog>
</template>
<script>
import { toPlainObject } from "lodash";
import axios from "../../../axios-auth";
import moment from "moment";
export default {
    data: (vm) => ({
        deshabilitar: false,
        fecha: moment().format("DD/MM/YYYY"),
        monto: "",
        numop: "",
        archivado: "",
        entidadLocal: "",
    }),
    props: ["visible", "codgral", "descr", "entidad", "frecuencia"],
    watch: {
        entidad(newVal) {
            // En caso de que el padre cambie la prop, se actualiza la local
            this.entidadLocal = newVal;
        }
    },
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    //this.$refs.form.resetValidation();
                    //this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargardatos() {
            let self = this;
            let codgral = this.codgral;
            axios
                .get("/RRHH/Cargarobligacionrrhh", {
                    params: {
                        codgral: codgral,
                    }
                })
                .then((response) => {
                    self.monto = response.data.monto;
                    //self.entidad = response.data.entidad;
                    self.archivado = response.data.archivado;
                })
                .catch((error) => {
                });
        },


        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Obligación",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        codgral: this.codgral,
                        descr: this.descr,
                        monto: this.monto,
                        entidad: this.entidadLocal,
                        numop: this.numop,
                        archivado: this.archivado,
                        fecha: this.fecha,
                        frecuencia: this.frecuencia

                    };

                    let self = this;
                    axios
                        .post("/RRHH/GuardarObligacionRRHH", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Obligación guardada con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            setTimeout(() => {
                                self.$router.push({ name: "ObligacionesRRHHListado" });
                            }, 2000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        vaciarListado() {
            this.fecha = "";
            this.monto = "";
            this.entidadLocal = "";
            this.numop = "";
            this.archivado = "";
            this.deshabilitar = false;
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 1500,
            });
        },
    },
};
</script>